export default {
  ACCOUNT: '/compte',
  INFO: '/informations',
  ORDERS: '/commandes',
  ADDRESSES: '/adresses',
  TRACKING: '/suivi-commande',
};
